import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Form, Button, Container, Row, Col, Image } from 'react-bootstrap';
import { getUserSession } from '../component/userInfo';
import { auth } from '../component/fbase'; // Firebase auth 객체 import

// v9+ 문법이므로 이 라인을 삭제하거나 주석 처리합니다.
// import { sendPasswordResetEmail } from 'firebase/auth'; 

const UserForm = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [name, setName] = useState('');
  const [photoURL, setPhotoURL] = useState('');
  const [email, setEmail] = useState('');

  const admin_uid = location.state?.admin_uid;

  useEffect(() => {
    if (!admin_uid) {
      alert('사용자 정보가 없습니다.');
      navigate('/UserList');
      return;
    }

    const fetchUserData = async () => {
      try {
        const formData = new FormData();
        formData.append('action', 'detail');
        formData.append('uid', admin_uid);

        const res = await fetch('/json/users.php', { 
          method: 'POST',
          body: formData 
        });
        const json = await res.json();

        if (json.user) {
          setUser(json.user);
          setName(json.user.name || '');
          setPhotoURL(json.user.photo || '');
          setEmail(json.user.email || '');
        } else {
          throw new Error(json.message || '사용자 정보를 불러오지 못했습니다.');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        alert(error.message);
        navigate('/UserList');
      }
    };

    fetchUserData();
  }, [admin_uid, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const userSession = getUserSession();

    try {
      const formData = new FormData();
      formData.append('action', 'update');
      formData.append('uid', admin_uid);
      formData.append('name', name);
      formData.append('photo', photoURL);
      formData.append('changer', userSession.uid);

      const res = await fetch('/json/users.php', {
        method: 'POST',
        body: formData,
      });
      const result = await res.json();

      if (result.success) {
        alert('사용자 정보가 성공적으로 수정되었습니다.');
        navigate('/UserList');
      } else {
        throw new Error(result.message || '정보 수정에 실패했습니다.');
      }
    } catch (error) {
      console.error('Error updating user data:', error);
      alert(error.message);
    }
  };

  // 비밀번호 초기화 핸들러 (v8 방식으로 수정)
  const handlePasswordReset = async () => {
    if (!email) {
      alert("이메일 주소가 없어 비밀번호를 재설정할 수 없습니다.");
      return;
    }

    if (window.confirm(`'${email}' 주소로 비밀번호 재설정 이메일을 발송하시겠습니까?`)) {
      try {
        // 구버전(v8) 방식: auth 객체의 메소드를 직접 호출
        await auth.sendPasswordResetEmail(email);
        alert("비밀번호 재설정 이메일이 성공적으로 발송되었습니다. 사용자의 이메일함을 확인하도록 안내해주세요.");
      } catch (error) {
        console.error("Error sending password reset email:", error);
        alert(`오류가 발생했습니다: ${error.message}`);
      }
    }
  };

  if (!user) {
    return <div>사용자 정보를 불러오는 중...</div>;
  }

  return (
    <Container>
      <h1 className="h3 my-4 text-gray-800">사용자 정보 수정</h1>
      <Row>
        {photoURL && (
          <Col md={4}>
            <Image src={photoURL} thumbnail />
          </Col>
        )}
        <Col md={photoURL ? 8 : 12}>
          <Form onSubmit={handleSubmit}>
            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="2">이메일</Form.Label>
              <Col sm="10">
                <Form.Control type="email" value={email} readOnly disabled />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="2">이름</Form.Label>
              <Col sm="10">
                <Form.Control
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="사용자 이름"
                />
              </Col>
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
              <Form.Label column sm="2">사진 URL</Form.Label>
              <Col sm="10">
                <Form.Control
                  type="text"
                  value={photoURL}
                  onChange={(e) => setPhotoURL(e.target.value)}
                  placeholder="http://example.com/photo.jpg"
                />
              </Col>
            </Form.Group>

            <div className="mt-4">
              <Button variant="primary" type="submit">
                저장
              </Button>
              <Button variant="secondary" onClick={() => navigate('/UserList')} className="ms-2">
                취소
              </Button>
              <Button variant="warning" onClick={handlePasswordReset} className="ms-2">
                비밀번호 초기화
              </Button>
            </div>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default UserForm;
